import { render } from "./SimplifiedBilling.vue?vue&type=template&id=539803bb"
import script from "./SimplifiedBilling.vue?vue&type=script&lang=js"
export * from "./SimplifiedBilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__